import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {GetMetricInstanceAlertStatusCB} from "../../ope/alert/GetMetricInstanceAlertStatusCB";
import {PutMetricInstanceAlertCB} from "../../ope/alert/PutMetricInstanceAlertCB";
import {GetMetricInstanceAlertEventsCB} from "../../ope/alert/GetMetricInstanceAlertEventsCB";
import {GetMetricInstanceAlertStatusDetailCB} from "../../ope/alert/GetMetricInstanceAlertStatusDetailCB";
import {DelMetricInstanceAlertCB} from "../../ope/alert/DelMetricInstanceAlertCB";
import {DuplicateMetricInstanceAlertCB} from "../../ope/alert/DuplicateMetricInstanceAlertCB";
import {GetWeekCalendarCB} from "../../ope/alert/GetWeekCalendarCB";
import {PutWeekCalendarCB} from "../../ope/alert/PutWeekCalendarCB";

@Injectable({
  providedIn: 'root'
})
export class AlertOpeService extends BaseOPEService {

  public getMetricInstanceAlertStatus(cb: GetMetricInstanceAlertStatusCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getMetricInstanceAlertStatusDetail(cb: GetMetricInstanceAlertStatusDetailCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putMetricInstanceAlert(cb: PutMetricInstanceAlertCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getMetricInstanceAlertEvents(cb: GetMetricInstanceAlertEventsCB): Promise<any> {
    return this.execOPE(cb);
  }

  public duplicateMetricInstanceAlert(cb: DuplicateMetricInstanceAlertCB): Promise<any> {
    return this.execOPE(cb);
  }

  delMetricInstanceAlert(cb: DelMetricInstanceAlertCB): Promise<any> {
    return this.execOPE(cb)
  }

  public getWeekCalendar(cb: GetWeekCalendarCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putWeekCalendar(cb: PutWeekCalendarCB): Promise<any> {
    return this.execOPE(cb);
  }
}
